import React from 'react';
import { motion } from 'framer-motion';

const TermsOfUse = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen py-20"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-eagle-dark mb-8">Terms of Use</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-700 mb-6">
            Welcome to Eagle Closing. These Terms of Use ("Terms") govern your access to and use of the Eagle Closing website located at https://eagleclosing.com (the "Site"). By accessing or using the Site, you agree to be bound by these Terms.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Acceptance of Terms</h2>
          <p className="text-gray-700 mb-4">
            By accessing and using this Site, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Use License</h2>
          <p className="text-gray-700 mb-4">
            Permission is granted to temporarily download one copy of the materials on Eagle Closing's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to decompile or reverse engineer any software contained on Eagle Closing's website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Disclaimer</h2>
          <p className="text-gray-700 mb-4">
            The materials on Eagle Closing's website are provided on an 'as is' basis. Eagle Closing makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Limitations</h2>
          <p className="text-gray-700 mb-4">
            In no event shall Eagle Closing or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Eagle Closing's website, even if Eagle Closing or a Eagle Closing authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Accuracy of Materials</h2>
          <p className="text-gray-700 mb-4">
            The materials appearing on Eagle Closing's website could include technical, typographical, or photographic errors. Eagle Closing does not warrant that any of the materials on its website are accurate, complete, or current. Eagle Closing may make changes to the materials contained on its website at any time without notice.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Links</h2>
          <p className="text-gray-700 mb-4">
            Eagle Closing has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Eagle Closing of the site. Use of any such linked website is at the user's own risk.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Modifications</h2>
          <p className="text-gray-700 mb-4">
            Eagle Closing may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Governing Law</h2>
          <p className="text-gray-700 mb-4">
            These terms and conditions are governed by and construed in accordance with the laws of Pennsylvania and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
          </p>

          <h2 className="text-2xl font-semibold text-eagle-dark mt-8 mb-4">Contact Information</h2>
          <p className="text-gray-700 mb-4">
            If you have any questions about these Terms of Use, please contact us at:
          </p>
          <p className="text-gray-700 mb-4">
            Eagle Closing<br />
            1100 West Valley Road, Suite 8<br />
            Wayne, PA 19087<br />
            Email: web@eagleclosing.com<br />
            Phone: 484-580-8865
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default TermsOfUse;

